import { error } from 'cc';
import Lobby from '../../System/Lobby';
import ResumeGamePopup from '../UI/Popup/ResumeGamePopup';
import HistoryPage from '../UI/Popup/HistoryPage';
import LoadingMachineTransition from '../UI/GameObject/LoadingMachineTransition';
import FeatureErrorName from '../Data/Config/FeatureErrorName';
import TableModel, { MachineState } from '../../../tableEngine/Script/Game/Data/Model/TableModel';
import Page from '../../../common/scripts/Toolkit/Components/Page/Page';
import globalInstance from '../../../common/scripts/System/GlobalInstance';
import { FeatureActivityDataType, FeatureActivityEventName } from '../Data/Config/FeatureActivityConfig';
import { EnterTableOption } from '../../../tableEngine/Script/Game/Data/Model/HallModel';
import NodeName from '../Data/Config/SceneNodeName';
import SlotGameText from '../Data/Config/SlotGameTextSet';

class EnterTableFlow {
    private _resumeGameDialog: ResumeGamePopup = null;
    private _loadingMachineTransition: LoadingMachineTransition = null;
    private _historyPage: Page = null;
    private _menuPage: Page = null;

    constructor() {
        globalInstance.waitForGameRegistered('game').then(() => {
            Lobby.event.on(HistoryPage.EVENT_TYPE.ENTER_MACHINE_FROM_HISTORY, this.enterFromHistory, this);
        });
    }

    private get historyPage() {
        if (!this._historyPage) {
            this._historyPage = Lobby.scene.getNode(NodeName.HistoryPage).getComponent(Page);
        }
        return this._historyPage;
    }

    private get menuPage() {
        if (!this._menuPage) {
            this._menuPage = Lobby.scene.getNode(NodeName.LobbyMenuPage).getComponent(Page);
        }
        return this._menuPage;
    }

    private get resumeGameDialog() {
        if (!this._resumeGameDialog) {
            this._resumeGameDialog = Lobby.scene.getNode(NodeName.ResumeGameDialog).getComponent(ResumeGamePopup);
        }
        return this._resumeGameDialog;
    }

    private get loadingMachineTransition() {
        if (!this._loadingMachineTransition) {
            this._loadingMachineTransition = Lobby.scene.getNode(NodeName.LoadingMachineTransition).getComponent(LoadingMachineTransition);
        }
        return this._loadingMachineTransition;
    }

    public findTableCanBeResumed(): number {
        // TODO handle game resume logic
        return -1;
        // check if any table has data, if so, trying to enter the table
        // const hasBetTable = FeatureGame.hall.tableModelList.find((table) => table.bettingModel.userBet);
        // if (hasBetTable) {
        //     if (hasBetTable.bettingModel.userBet) {
        //         log(`find table ${hasBetTable.tableID} with user bet exist`);
        //     }
        // }
        // return hasBetTable?.tableID ?? -1;
    }

    public async resumeFromDisconnect() {
        const resumeTableID = enterTableFlow.findTableCanBeResumed();
        if (resumeTableID !== -1) {
            enterTableFlow.enter({ tableID: resumeTableID }, FeatureActivityDataType.EnterGameLocation.ResumeGamePopup, true);
        }
    }

    public async enter(enterTableOptions: Partial<EnterTableOption>, from: FeatureActivityDataType.EnterGameLocation, isResumed = false): Promise<boolean> {
        // TODO: MSlot
        const hasBetTable = Lobby.hall.tableModelList.find((table) => table.bettingModel.userBet);
        if (hasBetTable && ((enterTableOptions.tableID && hasBetTable.tableID !== enterTableOptions.tableID) || isResumed)) {
            if (!isResumed) {
                const enter = await this.resumeGameDialog.showResumeHint(hasBetTable);
                if (!enter) {
                    return false;
                }
            }
            if (!hasBetTable.bettingModel.userBet) {
                Lobby.notification.show(SlotGameText.CAN_NOT_RETURN_TO_GAME);
                return false;
            }
            enterTableOptions = { tableID: hasBetTable.tableID };
            from = FeatureActivityDataType.EnterGameLocation.ResumeGamePopup;
        }

        if (enterTableOptions.tableID) {
            const targetTable = Lobby.hall.getTableByID(enterTableOptions.tableID);
            if (targetTable) {
                if (targetTable.playing && !targetTable.bettingModel.userBet) {
                    Lobby.error.handle(FeatureErrorName.TABLE_IS_FULL);
                    return false;
                }
                if (targetTable.machineState === MachineState.ComingSoon || targetTable.machineState === MachineState.Maintenance) {
                    Lobby.error.handle(FeatureErrorName.TABLE_IS_CLOSED);
                    return false;
                }
            }
        }
        let exitTableReason: FeatureErrorName = null;
        const [isSuccess, enterFailedReason] = (
            await Promise.all([
                Lobby.hall.enterTable(enterTableOptions).then((response) => {
                    if (response[0]) {
                        Lobby.currentTable.once(TableModel.EVENT_TYPE.EXIT_TABLE, (exitManually: boolean, reason: FeatureErrorName) => {
                            exitTableReason = reason;
                        });
                    }
                    return response;
                }),
                this.loadingMachineTransition.display(),
            ])
        )[0];
        if (!isSuccess) {
            Lobby.error.handle(enterFailedReason);
            this.loadingMachineTransition.hide();
            return false;
        }
        if (Lobby.currentTable) {
            Lobby.activity.send(FeatureActivityEventName.EnterGame, { From: from });
            // // HACK
            // TODO: MSlot
            // Lobby.scene.enter(SceneName.SinglePlay);
            // Lobby.activity.send(FeatureActivityEventName.GameShow, { MachineID: Lobby.currentTable.tableID });
            this.loadingMachineTransition.hide();
            return true;
        }
        if (exitTableReason) {
            Lobby.error.handle(exitTableReason);
        } else {
            error('exit table before changing scene without any reason');
        }
        this.loadingMachineTransition.hide();
        return false;
    }

    public async enterFromHistory(tableID: number) {
        // ensure resume game popup is on top of history page
        this.resumeGameDialog.node.zIndex = this.historyPage.node.zIndex + 1;
        if (tableID === -1) {
            Lobby.error.handle(FeatureErrorName.NO_TABLE_FOUND);
            return;
        }
        if (await enterTableFlow.enter({ tableID }, FeatureActivityDataType.EnterGameLocation.MachineRecord)) {
            this.historyPage.close(true, false).then(() => {
                this.menuPage.close(true, false);
            });
        }
    }
}

const enterTableFlow = new EnterTableFlow();

export default enterTableFlow;
